import { render, staticRenderFns } from "./Polity.vue?vue&type=template&id=09955079"
import script from "./Polity.vue?vue&type=script&lang=js"
export * from "./Polity.vue?vue&type=script&lang=js"
import style0 from "./Polity.vue?vue&type=style&index=0&id=09955079&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports